import { render } from "./Accueil.vue?vue&type=template&id=7f531c96"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=7f531c96&lang=css"
script.render = render

export default script